module.exports = __webpack_public_path__ + "img/242.cf7cfdf7.png";